import { type ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { useServizi } from './ServiziProvider'

export const ETICHETTE_MODULI: Record<string, string> = {
  serviziMassivi: 'Servizi massivi',
  dashboardUtenteFinale: 'Dashboard utente finale',
  monitoraggioEdistribuzione: 'Monitoraggio Energia',
  monitoraggioGse: 'Monitoraggio GSE',
  scadenze: 'Scadenze',
  mailingAutomatico: 'Mailing automatico',
  alertEdistribuzione: 'Indicatori di performance e Alert',
  portaliPersonalizzati: 'Portali personalizzati',
  reportEdistribuzione: 'Report periodici E-Distribuzione',
  reportGSE: 'Report periodici GSE',
  registroLetture: 'Registri letture',
}

// ponytail: markup semantico, niente MUI. Nessun test/consumatore di SP2 richiede
// componenti MUI; entra quando un task ne usa uno vero (data grid, form complessi).
export function Guardia({ modulo, children }: { modulo: string; children: ReactNode }) {
  const { eAttivo } = useServizi()
  const { idPartner } = useParams()
  if (eAttivo(modulo)) return <>{children}</>

  return (
    <section data-testid="modulo-da-attivare" className="modulo-da-attivare">
      <h2>Attiva il modulo per usare questa sezione</h2>
      <p>
        Il modulo <strong>{ETICHETTE_MODULI[modulo] ?? modulo}</strong> non risulta attivo sul tuo
        contratto.
      </p>
      <a href={`/cliente/${idPartner}/servizi`}>Vai a Gestione Servizi</a>
    </section>
  )
}
